import about from 'data/about.fr.json';
import projects from 'data/projects.fr.json';
import type { en } from './en';

// Typed against `en` so a missing or misspelled key fails the build.
export const fr: typeof en = {
  about,
  projects,
  languageSelect: 'Langue',
  themeToggle: 'Changer de thème',
  nav: {
    home: 'Accueil',
    about: 'À propos',
    experience: 'Expérience',
    projects: 'Projets',
    articles: 'Articles',
    contact: 'Contact',
    getInTouch: 'Me contacter',
    openMenu: 'Ouvrir le menu',
    closeMenu: 'Fermer le menu',
  },
  hero: {
    badge: 'Ingénieur Full Stack',
    greeting: 'Bonjour, je suis',
    subtitle: 'Je conçois des applications performantes',
    intro: "Développeur Full Stack passionné, expérimenté dans la création d'applications web modernes, de la conception au déploiement. Je crée des solutions",
    secure: 'sécurisées',
    scalable: 'évolutives',
    and: 'et',
    userFriendly: 'intuitives',
    outro: 'en suivant les bonnes pratiques du secteur et les méthodologies Agile.',
    getInTouch: 'Me contacter',
    viewProjects: 'Voir les projets',
  },
  aboutSection: {
    badge: 'À propos de moi',
    title: 'Ingénieur Full Stack',
    description:
      "Passionné par la création d'applications performantes et sécurisées, fondées sur une architecture propre. J'allie expertise technique et solides capacités de résolution de problèmes pour livrer des solutions centrées sur l'utilisateur.",
    technicalSkills: 'Compétences techniques',
    backend: 'Développement Backend',
    frontend: 'Développement Frontend',
    database: 'Bases de données & stockage',
    devops: 'DevOps & Cloud',
    practices: 'Pratiques & méthodologies',
  },
  experienceSection: {
    badge: 'Parcours',
    title: 'Expérience professionnelle',
    description: 'Des solutions à fort impact dans la fintech, le paiement électronique et les plateformes d’entreprise.',
    internship: 'Stage',
    fullTime: 'CDI',
  },
  projectsSection: {
    badge: 'Portfolio',
    title: 'Projets professionnels',
    description:
      "Des solutions d'entreprise basées sur une architecture microservices, une authentification sécurisée et des technologies full stack modernes, dans des domaines variés.",
    internshipProjects: 'Projets de stage',
  },
  articlesSection: {
    badge: 'Blog & réflexions',
    title: 'Articles techniques',
    description:
      "J'écris sur le développement full stack, les bonnes pratiques de code propre et l'ingénierie logicielle moderne. Tout est désormais sur mon blog.",
    cta: 'Lire mon blog',
  },
  contactSection: {
    badge: 'Me contacter',
    title: 'Travaillons ensemble',
    description:
      "Je suis actuellement disponible pour des missions freelance ou un poste à temps plein. Discutons de la façon dont je peux concrétiser vos idées.",
    infoTitle: 'Coordonnées',
    infoDescription: "N'hésitez pas à me contacter via l'un de ces canaux",
    email: 'E-mail',
    location: 'Localisation',
    linkedinValue: 'Restons en contact',
    remote: 'Disponible en télétravail',
    messageTitle: 'Message rapide',
    messageDescription: 'Envoyez-moi un message ou planifions un appel',
    helpTitle: 'Comment je peux vous aider :',
    helpItems: [
      "Développement d'applications web full stack",
      'Conception et architecture microservices',
      'Revue et optimisation de code',
      'Conseil technique et mentorat',
    ],
    responseTitle: 'Délai de réponse :',
    responseText: "Je réponds généralement sous 24 heures en semaine. Au plaisir d'échanger avec vous !",
    sendEmail: 'Envoyer un e-mail',
    connectLinkedin: 'Me rejoindre sur LinkedIn',
    ctaTitle: 'Ouvert aux opportunités',
    ctaText: "J'explore actuellement de nouveaux défis en développement full stack et en architecture microservices.",
    downloadResume: 'Télécharger le CV',
    viewGithub: 'Voir mon profil GitHub',
  },
  footer: {
    tagline: "Ingénieur Full Stack passionné par la création d'applications performantes et sécurisées, fondées sur une architecture propre.",
    quickLinks: 'Liens rapides',
    getInTouch: 'Me contacter',
    openToOpportunities: 'Ouvert à de nouvelles opportunités',
    remote: 'Disponible en télétravail',
    rights: 'Tous droits réservés.',
  },
  scrollToTop: 'Retour en haut',
};
